import React from 'react';
import Footer from './Footer/Footer';
import { ToastContainer, toast } from 'react-toastify';

function Layout({ header, children, className }) {
  return (
    <div className="flex min-h-screen flex-col">
      <main className={`flex-grow ${className}`}>{children}</main>
      <Footer />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        limit={3}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default Layout;
